import * as React from 'react';
import { Redirect } from 'react-router';
import { isLoggedIn } from '../api/api-account';

interface State {

}

export interface Props {
}

class PrivateRoutes extends React.Component<Props, State> {

  render() {
    if (isLoggedIn()) {
      return this.props.children
    } else {
      return <Redirect push={true} to='/login' />
    }
  }
}

export default PrivateRoutes;